import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchAllSpecialities, searchSpecialities, fetchSpecialtiesBanner, fetchSpecialtyPageSeo } from "../Adapter/PageAdapter";
import { baseImage_path } from "../variables/Variables";
import useSeo from "../hooks/useSeo";
import SeoHelmet from "../components/SeoHelmet";
import bannerImage from "../assets/images/spciallites/speciban.jpg"; // Adjust the path based on your project structure
import searchIcon from "../assets/images/spciallites/searchblk.png";
import blackArrImg from "../assets/images/spciallites/blkarw.svg";

// Helper function to limit text to a specific word count
const truncateWords = (text, wordLimit = 15) => {
    if (!text) return "";
    const words = text.split(/\s+/);
    return words.length > wordLimit
        ? words.slice(0, wordLimit).join(" ") + "..."
        : text;
};

const truncateLines = (text, lines = 2) => {
    if (!text) return "";
    const words = text.split(/\s+/);
    const lineHeight = 1.4; // Adjust this based on CSS line height
    const maxChars = lines * 25; // Approximate characters per line
    return words.join(" ").length > maxChars
        ? words.join(" ").substring(0, maxChars) + "..."
        : words.join(" ");
};


const Specialities = () => {
    const [specialities, setSpecialities] = useState([]);
    const [visibleCount, setVisibleCount] = useState(12);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [bannerData, setBannerData] = useState([]);
    const { slug } = useParams();
    const navigate = useNavigate();
    const [seoData, setSeoData] = useState(null);

    useEffect(() => {
        const loadSeo = async () => {
            try {
                console.log("Calling fetchSpecialtyPageSeo...");
                const res = await fetchSpecialtyPageSeo();
                console.log("API Response:", res);
                if (res && res.data) {
                    setSeoData(res.data);
                }
            } catch (e) {
                console.error("Direct SEO fetch failed:", e);
            }
        };

        loadSeo();
    }, []);

    // const seoData = useSeo(fetchSpecialtyPageSeo);

    useEffect(() => {
        const fetchData = async () => {
            const bannerResponse = await fetchSpecialtiesBanner();
            if (bannerResponse && bannerResponse.data) {
                setBannerData(bannerResponse.data);
            }
        };

        fetchData();
    }, []);

    // Fetch all specialties on component mount
    useEffect(() => {
        const fetchSpecialties = async () => {
            setLoading(true);
            try {
                const response = await fetchAllSpecialities();
                if (response && response.specialities) {
                    setSpecialities(response.specialities);
                }
            } catch (error) {
                console.error("Error fetching specialties:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchSpecialties();
    }, []);

    // Handle search input change (Debounced Search)
    const handleSearch = async (e) => {
        const query = e.target.value;
        setSearchTerm(query);

        if (query.length > 2) {
            try {
                const response = await searchSpecialities(query);
                if (response && response.data) {
                    setSpecialities(response.data);
                } else {
                    setSpecialities([]); // Clear list if no results found
                }
            } catch (error) {
                console.error("Error searching specialties");
            }
        } else {
            const response = await fetchAllSpecialities();
            if (response && response.specialities) {
                setSpecialities(response.specialities);
            }
        }
    };

    // const handleReadMore = (id) => {
    //     window.scrollTo(0, 0);
    //     navigate(`/specialities/${id}`);
    // };

    const handleSpecialityClick = (id, name, slug) => {
        const formattedName = slug.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
        localStorage.setItem("specialityId", id);
        navigate(`/specialities/${formattedName}`);
    };

    // Load More Function
    const handleLoadMore = () => {
        setVisibleCount((prevCount) => prevCount + 16); // Increase by 12
    };

    if (loading) return <p>Loading specialties...</p>;

    return (
        <div>
            {seoData && <SeoHelmet seoData={seoData} />}
            {/* Banner Section */}
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        {bannerData && bannerData.img_path ? (
                            <img
                                src={`${baseImage_path}${bannerData.img_path.replace('.', '')}`}
                                alt={bannerData.banner_heading || "Specialties"}
                            />
                        ) : (
                            <img src={bannerImage} alt="Specialties" />
                        )}
                        <div className="ban-con">
                            <h1>{bannerData[0]?.banner_heading || 'Specialties'}</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Specialty Search Section */}
            <section className="section about-host specialty-search-sec">
                <div className="cust-container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                            <div className="finnest host-det">
                                <h4>
                                    Comprehensive Care Across a
                                    <span> Spectrum of Specialties</span>
                                </h4>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                            <div className="specialty-search width100">
                                <form className="example">
                                    <input
                                        type="text"
                                        placeholder="Search by Specialties"
                                        name="search"
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                    <button type="submit">
                                        <img src={searchIcon} alt="Search" />
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Specialties List Section */}
            <section className="specialites-sec mrgntop70 margnbot90 healthcheckup-sec">
                <div className="cust-container">
                    <div className="row">
                        {specialities.length > 0 ? (
                            specialities.slice(0, visibleCount).map((specialty) => (
                                <div
                                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
                                    key={specialty.id}
                                >
                                    <div className="specialites-item">
                                        <div className="specialttm-img">
                                            <img
                                                src={
                                                    specialty.img_path
                                                        ? `${baseImage_path}/${specialty.img_path}`
                                                        : `${baseImage_path}/images/default-speciality.png`
                                                }
                                                alt={specialty.name}
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="spcialttm-desc">
                                            <h4>{specialty.name}</h4>
                                            {/* <p>{truncateLines(specialty.description || "No description available.", 2)}</p> */}
                                            <p dangerouslySetInnerHTML={{ __html: truncateLines(specialty.description || "No description available.", 2) }} />
                                        </div>
                                        <div className="specialttm-cta">
                                            <button onClick={() => handleSpecialityClick(specialty.id, specialty.name, specialty.slug)} style={{ background: "transparent" }}>
                                                Read More{" "}
                                                <img src={blackArrImg} alt="Arrow" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            // Display this message if no specialties are found
                            <div className="col-12 text-center mt-4">
                                <p>No Specialties Found. Please try searching with a different search term.</p>
                            </div>
                        )}
                    </div>

                    {/* Load More Button */}
                    {visibleCount < specialities.length && specialities.length > 0 && (
                        <div className="text-center mt-4">
                            <button className="btn with-color" onClick={handleLoadMore}>
                                Load More
                            </button>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Specialities;
